// src/utils/missionUtils.js

/**
 * Transforms the user accomplishmentsManifest object into an array of mission data.
 * @param {object} accomplishmentsManifest
 * @returns {Array}
 */
export function parseMissionsData(accomplishmentsManifest) {
  if (!accomplishmentsManifest) return [];
  return Object.keys(accomplishmentsManifest).map((key) => {
    const mission = accomplishmentsManifest[key];
    return {
      title: mission.missionTitle,
      statuses: [
        mission.coins.rookie.status,
        mission.coins.intermediate.status,
        mission.coins.advanced.status,
      ],
      completed: [
        mission.coins.rookie.status === "completed",
        mission.coins.intermediate.status === "completed",
        mission.coins.advanced.status === "completed",
      ],
      coins: mission.coins,
    };
  });
}
